
import { useSearchParams } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import Helper from 'src/helper/Helper';
import { useQuoteStore } from "../../hooks/quote";
import moment from "moment";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Constants from 'src/helper/Constants';
import stickyTableCommon from 'src/helper/stickyTableCommon';
import { useObjCommonFilterStore } from "../../hooks/objCommonFilter";
import { useProductStore } from "../../hooks/product";
import QuoteDetail from '@system/config/quote';
import System from "../../helper/system";
import { __remove, __set } from "../../store/axios_indicator";
import Pagination from "src/component/Global/Pagination"
import NoResultContent from "../HomePageContent/NoResultContent";
import { Tooltip } from "rsuite";
import NavigateToProductDetail from "../../component/custom/NavigateToProductDetail";

export function SubmittedQuoteFilterList() {
    const [__check] = useAxiosIndicatorCheck();
    const [{ searchQuoteList }, { fetch_search_quote_list }, { }] = useQuoteStore();
    const [searchParams] = useSearchParams();
    const [{ filter_list }, { }] = useObjCommonFilterStore();
    const [listObj, setListObj] = useState({
        pageCount: 0,
        page: searchParams.get("page") ? searchParams.get("page") : 1,
        limit: searchParams.get("limit") ? searchParams.get("limit") : 20,
        sortBy: 'quotelinenumber',
        sortOrder: 'ASC',
        ascDesField: {}
    })
    const { QuoteTabList: { PND }, currencyType: { USD }, siteUser, noValue } = Constants
    const isCoreUser = System.avUserInfoData.currentUser === siteUser.CORE
    const [{ productList }, { }, { }] = useProductStore();
    const setPageLimit = async (event) => {
        setListObj({ ...listObj, limit: Number(event.target.value), page: 1 });
    };

    useEffect(() => {
        fetchAPICall()
    }, [filter_list, listObj.page, listObj.limit, listObj.sortBy, listObj.sortOrder]);

    useEffect(() => {
        if (searchQuoteList && Object.keys(searchQuoteList).length > 0) {
            const total = searchQuoteList.totalRecords;
            setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit) })
        }
    }, [searchQuoteList]);

    const fetchAPICall = async () => {
        let expDt = filter_list.expirationDate?.searchKeyword;
        expDt = expDt ? setDateForFilter(expDt) : expDt;

        let submissionDt = filter_list.submissionDate?.searchKeyword;
        submissionDt = submissionDt ? setDateForFilter(submissionDt) : submissionDt;
        const params = {
            displayQuoteNumber: filter_list.quoteNumber?.searchKeyword || undefined,
            quoteSubmissionDateFrom: submissionDt ? submissionDt[0] + " 00:00:00" : undefined,
            quoteSubmissionDateTo: submissionDt ? submissionDt[1] + " 23:59:59" : undefined,
            quoteExpirationDateFrom: expDt ? expDt[0] + " 00:00:00" : undefined,
            quoteExpirationDateTo: expDt ? expDt[1] + " 23:59:59" : undefined,
            manufacturer: filter_list.manufacturer?.searchKeyword || undefined,
            manufacturerPartNumber: filter_list.manufacturerPartNumber?.searchKeyword || undefined,
            customerPartNumber: filter_list.customerPartNumber?.searchKeyword || undefined,
            quoteStatus: filter_list.status?.searchKeywordArr?.map(v => v.value).join(",").trim() || undefined,
            projectName: filter_list.projectName?.searchKeyword || undefined,
            buyer: filter_list.buyer?.searchKeyword || undefined,
            pageNumber: listObj.page,
            pageSize: listObj.limit,
            sortBy: "QuoteNumber:dsc",
        }
        __set("QUOTE_API_CALL")
        await fetch_search_quote_list(params)
        __remove("QUOTE_API_CALL")
    };

    const setDateForFilter = (dtObj) => {
        if (dtObj) {
            const _dt = dtObj.split("-");
            _dt[0] = moment(_dt[0]).local().format("MM/DD/YYYY");
            _dt[1] = moment(_dt[1]).local().format("MM/DD/YYYY");
            return _dt;
        }
        return '';
    }

    const handlePageClick = async (data) => {
        setListObj({ ...listObj, page: (data.selected + 1) });
        Helper.scrollTop();
    };

    const toggleOrderBy = async (columnName) => {
        if (listObj.ascDesField.hasOwnProperty(columnName)) {
            listObj.ascDesField[columnName] = listObj.ascDesField[columnName] === 'ASC' ? 'DSC' : 'ASC';
        } else {
            listObj.ascDesField[columnName] = 'ASC'
        }
        setListObj({
            ...listObj,
            sortBy: columnName,
            sortOrder: listObj.ascDesField[columnName],
            ascDesField: listObj.ascDesField
        })
    };

    useEffect(() => {
        if (searchQuoteList?.records && searchQuoteList?.records?.length > 0) {
            stickyTableCommon('submittedquotelisting-table', toggleOrderBy)
        }
    }, [searchQuoteList, __check(['QUOTE_API_CALL']).status])

    return (
        <>
            {__check(['QUOTE_API_CALL']).render}
            {!__check(['QUOTE_API_CALL']).status &&
                <>
                    {searchQuoteList && searchQuoteList?.records?.length > 0 ?
                        <>
                            <div className="p-0 mx-3">
                                <div id="tab1" className="tab-pane active table-container">
                                    <div id='sticky-table-wrapper' className="table-responsive sticky-table-wrapper">
                                        <table id='submittedquotelisting-table'
                                            className="bs5 table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th className='minw180'></th>
                                                    <th className='minw300'>Part Information</th>
                                                    <th className='minw170'>Quantity 1</th>
                                                    <th className='minw170'>Quantity 2</th>
                                                    <th className='minw170'>Quantity 3</th>
                                                    <th>Description</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {searchQuoteList?.records?.map((ele, i) => {
                                                    return <tr key={i}>
                                                        <td>
                                                            <b>Found in quote:</b> <br /> <a
                                                                href={QuoteDetail.getQuoteDetailPageRouteURL({ quote_number: ele.quoteNumber })}> {ele.displayQuoteNumber}-{ele.quoteRevisionNumber}
                                                            </a>
                                                        </td>
                                                        <td className="w250">
                                                            <div className={'d-flex flex-column'}>
                                                                <div className={'d-flex align-items-center'}><span
                                                                    className={'d-block minw110'}>Manufacturer:</span> {ele.quotedManufacturerName}
                                                                </div>
                                                                <div className={'d-flex align-items-center'}><span
                                                                    className={'d-block minw110'}>Mfg Part #:</span>
                                                                    {productList[ele.sapMaterialId]?.ItemNumber ?
                                                                    <NavigateToProductDetail
                                                                        data={{ SEOManufacturerName: productList[ele.sapMaterialId]?.SEOManufacturerName, SEOERPMFRPartNumber: productList[ele.sapMaterialId]?.SEOERPMFRPartNumber, ItemNumber: productList[ele.sapMaterialId]?.ItemNumber, ERPPartNumber: null }}>
                                                                        {ele.quotedMFRPartNumber}
                                                                    </NavigateToProductDetail>
                                                                    : ele.quotedMFRPartNumber}
                                                                </div>
                                                                <div className={'d-flex align-items-center'}><span
                                                                    className={'d-block minw110'}>Addt&apos;l Charge(s):</span> {ele.addionalCharges}
                                                                </div>
                                                            </div>

                                                            {(isCoreUser && ele?.customerPartnumber !== null) &&
                                                                <>
                                                                    <label className="mt-2"><b>Customer Part Number </b>
                                                                        <Tooltip
                                                                            opener={() => (
                                                                                <i className="fa fa-info-circle me-2" />
                                                                            )}
                                                                            content={() => (
                                                                                <>
                                                                                    {'Pricing is associated with displayed Customer Part Number (CPN). If a different CPN is selected, pricing will be re-determined.'}
                                                                                </>
                                                                            )}
                                                                        />

                                                                    </label>
                                                                    <div>
                                                                        <div>{ele.customerPartnumber}</div>
                                                                    </div>
                                                                </>
                                                            }
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <label>Sell Qty1:</label>
                                                                <span>{ele.currentStatus !== 'Pending' ? (ele.quotePriceDetails?.[0]?.quantity || noValue) : noValue}</span>
                                                            </div>
                                                            <div>
                                                                Target
                                                                Price:{ele.quotePriceDetails?.[0] ? (System.getFormatNumber({
                                                                    amount: Number(ele.quotePriceDetails?.[0]?.targetResale,),
                                                                    maximumFractionDigits: 2,
                                                                    isDisplaySymbol: false,
                                                                    currency: USD,
                                                                }) || 0) : noValue}
                                                            </div>
                                                            <div>
                                                                Quoted
                                                                Price:{ele.currentStatus !== 'Pending' ? System.getFormatNumber({
                                                                    amount: Number(ele.quotePriceDetails?.[0]?.quotedResale,),
                                                                    maximumFractionDigits: 2,
                                                                    isDisplaySymbol: false,
                                                                    currency: USD,
                                                                }) : noValue}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <label>Sell Qty2:</label>
                                                                <span>{ele.currentStatus !== 'Pending' ? (ele.quotePriceDetails?.[1]?.quantity || noValue) : noValue}</span>
                                                            </div>
                                                            <div>
                                                                Target
                                                                Price:{ele.quotePriceDetails?.[1] ? (System.getFormatNumber({
                                                                    amount: Number(ele.quotePriceDetails?.[1]?.targetResale,),
                                                                    maximumFractionDigits: 2,
                                                                    isDisplaySymbol: false,
                                                                    currency: USD,
                                                                }) || 0) : noValue}
                                                            </div>
                                                            <div>
                                                                Quoted
                                                                Price:{ele.currentStatus !== 'Pending' ? (System.getFormatNumber({
                                                                    amount: Number(ele.quotePriceDetails?.[1]?.quotedResale,),
                                                                    maximumFractionDigits: 2,
                                                                    isDisplaySymbol: false,
                                                                    currency: USD,
                                                                }) || 0) : noValue}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <label>Sell Qty3:</label>
                                                                <span>{ele.currentStatus !== 'Pending' ? (ele.quotePriceDetails?.[2]?.quantity || noValue) : noValue}</span>
                                                            </div>
                                                            <div>
                                                                Target
                                                                Price:{ele.quotePriceDetails?.[2] ? (System.getFormatNumber({
                                                                    amount: Number(ele.quotePriceDetails?.[2]?.targetResale,),
                                                                    maximumFractionDigits: 2,
                                                                    isDisplaySymbol: false,
                                                                    currency: USD,
                                                                }) || 0) : noValue}
                                                            </div>
                                                            <div>
                                                                Quoted
                                                                Price:{ele.currentStatus !== 'Pending' ? (System.getFormatNumber({
                                                                    amount: Number(ele.quotePriceDetails?.[2]?.quotedResale,),
                                                                    maximumFractionDigits: 2,
                                                                    isDisplaySymbol: false,
                                                                    currency: USD,
                                                                }) || 0) : noValue}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            {ele?.ERPPartNumber && productList[ele?.ERPPartNumber]?.ShortDescription}
                                                        </td>
                                                    </tr>
                                                })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            {searchQuoteList && searchQuoteList?.records?.length > 0 &&
                                <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick}
                                    setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
                            }
                        </>
                        :
                        <div className='mx-3'>
                            <NoResultContent message={"Sorry! No Result Found. We can't find any results based on your selection"}
                                isDisplay={false} />
                        </div>
                    }
                </>
            }
        </>
    );

}
